import { formatedDate } from '../Functions/convertDate';
import { formatedNumber } from '../Functions/convertNumber';

export const handlePrint = (reservation) => {
  const printWindow = window.open('', '_blank');
  const { selectedorganisme, selectedHotel, selectedRoom, pension, observations, currentDate, clients } = reservation;

  const styles = `
    @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;600;700&display=swap');
    
    * {
      margin: 0;
      padding: 0;
      box-sizing: border-box;
    }
    
    body {
      font-family: 'Roboto', Arial, sans-serif;
      background: #f8f9fa;
      color: #333;
      line-height: 1.4;
    }
    
    .voucher-container {
      max-width: 800px;
      margin: 20px auto;
      background: white;
      box-shadow: 0 4px 15px rgba(0,0,0,0.1);
      border-radius: 8px;
      overflow: hidden;
    }
    
    .voucher-header {
      background: linear-gradient(135deg, #2c3e50 0%, #3498db 100%);
      color: white;
      padding: 20px;
      text-align: center;
    }
    
    .voucher-title {
      font-size: 24px;
      font-weight: 700;
      margin-bottom: 5px;
    }
    
    .voucher-ref {
      font-size: 14px;
      opacity: 0.9;
      font-weight: 300;
    }
    
    .voucher-body {
      padding: 25px;
    }
    
    .info-section {
      background: #f8f9fa;
      border-radius: 8px;
      padding: 20px;
      margin-bottom: 25px;
      border-left: 4px solid #3498db;
    }
    
    .info-grid {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
      gap: 15px;
    }
    
    .info-item {
      display: flex;
      align-items: center;
    }
    
    .info-label {
      font-weight: 600;
      color: #2c3e50;
      min-width: 100px;
      margin-right: 10px;
    }
    
    .info-value {
      color: #555;
      font-weight: 400;
    }
    
    .section-title {
      font-size: 18px;
      font-weight: 600;
      color: #2c3e50;
      margin-bottom: 15px;
      border-bottom: 2px solid #3498db;
      padding-bottom: 5px;
    }
    
    .clients-table {
      width: 100%;
      border-collapse: collapse;
      background: white;
      border-radius: 8px;
      overflow: hidden;
      box-shadow: 0 2px 8px rgba(0,0,0,0.1);
    }
    
    .clients-table th {
      background: #3498db;
      color: white;
      padding: 12px 10px;
      font-weight: 600;
      text-align: left;
      font-size: 13px;
    }
    
    .clients-table td {
      padding: 10px;
      border-bottom: 1px solid #eee;
      font-size: 13px;
    }
    
    .clients-table tr:nth-child(even) {
      background-color: #f8f9fa;
    }
    
    .clients-table tr:hover {
      background-color: #e3f2fd;
    }
    
    .status-badge {
      padding: 4px 8px;
      border-radius: 12px;
      font-size: 11px;
      font-weight: 600;
      text-transform: uppercase;
    }
    
    .status-confirmed {
      background: #d4edda;
      color: #155724;
    }
    
    .status-pending {
      background: #fff3cd;
      color: #856404;
    }
    
    .observations {
      background: #fff9c4;
      border-left: 4px solid #ffc107;
      padding: 15px;
      margin: 20px 0;
      border-radius: 4px;
      font-style: italic;
      color: #666;
    }
    
    .footer {
      text-align: center;
      padding: 20px;
      background: #f8f9fa;
      color: #666;
      font-size: 12px;
      border-top: 1px solid #eee;
    }
    
    .print-date {
      text-align: right;
      color: #999;
      font-size: 11px;
      margin-bottom: 15px;
    }
    
    @media print {
      body {
        background: white;
      }
      .voucher-container {
        box-shadow: none;
        max-width: none;
        margin: 0;
      }
      .voucher-header {
        background: #2c3e50 !important;
        -webkit-print-color-adjust: exact;
      }
      .clients-table th {
        background: #3498db !important;
        -webkit-print-color-adjust: exact;
      }
    }
  `;

  const getStatusBadge = (status) => {
    const statusClass = status.toLowerCase() === 'confirmed' || status.toLowerCase() === 'confirmé' 
      ? 'status-confirmed' 
      : 'status-pending';
    return `<span class="status-badge ${statusClass}">${status}</span>`;
  };

  const clientRowsHTML = clients.map(client => `
    <tr>
      <td><strong>${client.passport}</strong></td>
      <td style="font-weight: 500;">${client.clientName}</td>
      <td>${formatedDate(client.checkInDate)}</td>
      <td>${formatedDate(client.checkOutDate)}</td>
      <td>${client.BCReference || '<em>Sans BC</em>'}</td>
      <td>${getStatusBadge(client.reservationStatus)}</td>
    </tr>
  `).join('');

  const htmlTemplate = `
    <!DOCTYPE html>
    <html lang="fr">
      <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <title>Voucher - ${reservation.id_reservation}</title>
        <style>${styles}</style>
      </head>
      <body>
        <div class="voucher-container">
          <!-- En-tête du voucher -->
          <div class="voucher-header">
            <h1 class="voucher-title">VOUCHER AGENCE DE VOYAGES</h1>
            <p class="voucher-ref">Référence: ${reservation.id_reservation}</p>
          </div>

          <div class="voucher-body">
            <!-- Date d'impression -->
            <div class="print-date">
              Imprimé le: ${formatedDate(currentDate)}
            </div>

            <!-- Informations de réservation -->
            <div class="info-section">
              <div class="info-grid">
                <div class="info-item">
                  <span class="info-label">Organisme:</span>
                  <span class="info-value">${selectedorganisme}</span>
                </div>
                <div class="info-item">
                  <span class="info-label">Hôtel:</span>
                  <span class="info-value">${selectedHotel}</span>
                </div>
                <div class="info-item">
                  <span class="info-label">Chambre:</span>
                  <span class="info-value">${selectedRoom}</span>
                </div>
                <div class="info-item">
                  <span class="info-label">Pension:</span>
                  <span class="info-value">${pension}</span>
                </div>
              </div>
            </div>

            <!-- Observations si présentes -->
            ${observations ? `
              <div class="observations">
                <strong>Observations:</strong> ${observations}
              </div>
            ` : ''}

            <!-- Liste des clients -->
            <div class="section">
              <h2 class="section-title">Liste des Voyageurs (${clients.length} ${clients.length > 1 ? 'personnes' : 'personne'})</h2>
              <table class="clients-table">
                <thead>
                  <tr>
                    <th style="width: 15%;">Passeport</th>
                    <th style="width: 25%;">Nom Complet</th>
                    <th style="width: 15%;">Arrivée</th>
                    <th style="width: 15%;">Départ</th>
                    <th style="width: 15%;">Réf. BC</th>
                    <th style="width: 15%;">Statut</th>
                  </tr>
                </thead>
                <tbody>
                  ${clientRowsHTML}
                </tbody>
              </table>
            </div>
          </div>

          <!-- Pied de page -->
          <div class="footer">
            <p><strong>Voucher valable pour présentation à l'hôtel</strong></p>
            <p>Document généré automatiquement - Agence de Voyages</p>
          </div>
        </div>
      </body>
    </html>
  `;

  printWindow.document.write(htmlTemplate);
  printWindow.document.close();
  printWindow.focus();
  
  // Attendre le chargement avant d'imprimer
  setTimeout(() => {
    printWindow.print();
    printWindow.close();
  }, 500);
};

const generateRowsHTML = (rows = [], formatter) => {
  if (!Array.isArray(rows)) {
    console.error("Expected an array for rows, but got:", rows);
    return '';
  }
  return rows.map(formatter).join('');
};